import React from "react";
import Context from "../../../Context";
import HeaderArea from "./HeaderArea";
export default class HeaderTop extends React.Component {
  static contextType = Context;
  render() {
    return <>{!this.context.isMobile ? <HeaderArea /> : null}</>;
  }
}
